// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3KFOw","content":"ManualTimeModal_content__aHvPP"};